import { render } from "./App.vue?vue&type=template&id=7d6bcc20"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7d6bcc20&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Downloads\\放射小程序\\后台\\manager\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__